// extracted by mini-css-extract-plugin
export default {"loaderLayout":"LoaderLayout_loaderLayout__+dLLf","loaderLayoutLoader":"LoaderLayout_loaderLayoutLoader__4j9ME"};